module.exports = "/img/7.90dbb9.webp";